<template>
  <div>
    <div class="title">
      <div>{{ $t("RAM.AWS.computeInstance.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:elasticComputeCloudResource:update'
          ]"
          :loading="updateLoading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          @click="exportList"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:elasticComputeCloudResource:export'
          ]"
          >{{ $t("common.export") }}</Button
        >
        <Button
          type="primary"
          :loading="modal_loading"
          @click="exportAWSInstanceMetrics"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:elasticComputeCloudResource:exportAWSInstanceMetric'
          ]"
          >{{ $t("common.exportMetricsStatistics") }}</Button
        >
        <Button
          type="primary"
          :loading="modal_loading"
          @click="exportAWSInstancesAndSecurityGroup"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:elasticComputeCloudResource:exportAWSInstancesAndSecurityGroup'
          ]"
          >{{ $t("RAM.common.multiLineExport") }}</Button
        >
      </div>
    </div>
    <table-elastic-compute-cloud-resource
      ref="child"
    ></table-elastic-compute-cloud-resource>
    <export ref="exportChild"></export>
  </div>
</template>

<script>
import ElasticComputeCloudResourceSearch from "../ec2/ElasticComputeCloudResourceSearch";
import TableElasticComputeCloudResource from "../ec2/TableElasticComputeCloudResource";
import Export from "../../aws/Export";

export default {
  name: "ElasticComputeCloudResource",
  components: {
    ElasticComputeCloudResourceSearch,
    TableElasticComputeCloudResource,
    Export
  },
  data() {
    return {
      modal_loading: false,
      updateLoading: false
    };
  },
  methods: {
    update: function() {
      this.updateLoading = true;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.$refs.child.$refs.child.companyId,
          accountIdList: this.$refs.child.$refs.child.accountSearchKey,
          resourceManagement: 0,
          accountType: 0
        })
        .then(res => {
          this.updateLoading = false;
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      this.$refs.exportChild.openExport(0);
    },
    export: function(chooseType) {
      var exportDTO = {
        companyId: this.$refs.child.$refs.child.companyId,
        accountIdList: this.$refs.child.$refs.child.accountSearchKey,
        queryList: this.$refs.child.$refs.child.queryList
      };
      // 点击 是
      if (chooseType == true) {
        this.$refs.exportChild.loading = true;
        exportDTO.exportWithTag = true;
      }
      // 点击 否
      else {
        this.$refs.exportChild.modal_loading = true;
        exportDTO.exportWithTag = false;
      }
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement.exportAWSInstance(exportDTO).then(res => {
        this.exportResponse(res);
        if (chooseType == true) {
          this.$refs.exportChild.loading = false;
        } else {
          this.$refs.exportChild.modal_loading = false;
        }
        // 关闭导出弹出框
        this.$refs.exportChild.exportModal = false;
      });
    },
    //多行导出
    exportAWSInstancesAndSecurityGroup: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAWSInstancesAndSecurityGroup({
          companyId: this.$refs.child.$refs.child.companyId,
          accountIdList: this.$refs.child.$refs.child.accountSearchKey,
          queryList: this.$refs.child.$refs.child.queryList
        })
        .then(res => {
          this.exportResponse(res);
          this.modal_loading = false;
        });
    },
    //导出指标统计
    exportAWSInstanceMetrics: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAWSInstanceMetrics({
          companyId: this.$refs.child.$refs.child.companyId,
          accountIdList: this.$refs.child.$refs.child.accountSearchKey,
          queryList: this.$refs.child.$refs.child.queryList
        })
        .then(res => {
          this.exportResponse(res);
          this.modal_loading = false;
        });
    },
    exportResponse: function(res) {
      let fileName = this.$t('RAM.export.computeInstance');
      let blob = new Blob([res.data], { type: "application/x-xls" });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      }
      this.$Message.destroy();
      this.$Message.success(this.$t('common.exportSuccess'));
    }
  }
};
</script>

<style scoped>
.title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.title > div:nth-child(1) {
  float: left;
}
.title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/ec2/ElasticComputeCloudResource.vue